import React from 'react';
import PropTypes from 'prop-types';

import I18N from '../../I18N';
import { capitalize } from "../../utils/stringManipulations";
import plusIcon from '../../assets/icons/Icon-Close.svg';
import "./NewCoachTile.scss";

const NewCoachTile = ({ onClick })=> {
  return (
    <button className="new-coach-tile" type="button" onClick={onClick} data-testid="new-coach-tile">
      <div className="new-coach-tile__circle">
        <img className="new-coach-tile__circle__plus" src={plusIcon} alt=""/>
      </div>
      <p className="new-coach-tile__text">{capitalize(I18N.t("ASSIGN_NEW_COACH"))}</p>
    </button>
  );
};

NewCoachTile.propTypes = {
  onClick: PropTypes.func
};

NewCoachTile.defaultProps = {
  onClick: ()=> {}
};

export default NewCoachTile;